import { useEffect, useRef } from 'react';
import { createEngine } from '../scene/engine';

// Apply a complete snapshot on engine creation. Ref assignment alone does not
// trigger React effects, so restored values must never rely on incidental order.
const syncEngine = (engine, next, previous = {}) => {
  if (next.mtVariant !== previous.mtVariant) engine.setMTVariant(next.mtVariant);
  if (next.selected !== previous.selected) engine.select(next.selected);
  if (next.mode !== previous.mode) engine.setMode(next.mode);
  if (next.openings !== previous.openings) engine.setOpenings(next.openings);
  if (next.screenExtensions !== previous.screenExtensions) engine.setScreenExtensions(next.screenExtensions);
  if (next.finish !== previous.finish || next.finishes !== previous.finishes) engine.setFinish(next.finishes.find(f => f.id === next.finish));
  if (next.lighting !== previous.lighting) engine.setLighting(next.lighting);
  if (next.installation !== previous.installation) engine.setInstallation(next.installation);
  if (next.fullRailFill !== previous.fullRailFill) engine.setFullRailFill(next.fullRailFill);
  if (next.measurements !== previous.measurements) engine.setMeasurements(next.measurements);
  if (next.railCompare !== previous.railCompare) engine.setRailCompare(next.railCompare);
  if (next.railDetail !== previous.railDetail) engine.inspectRail(next.railDetail);
  engine.renderNow();
};

export const ShowroomScene = ({ products, selected, mtVariant, roomConfig, mode, openings, screenExtensions, finish, finishes, lighting, installation, fullRailFill, measurements, railDetail, railCompare, apiRef, onSelect, onMode, onThumbnails, onReady, onError, onRailDetail }) => {
  const host = useRef(), ownedEngine = useRef(null), applied = useRef({});
  const callbacks = useRef({});
  callbacks.current = { onSelect, onMode, onThumbnails, onReady, onError, onRailDetail };
  const snapshot = useRef({});
  snapshot.current = { selected, mtVariant, mode, openings, screenExtensions, finish, finishes, lighting, installation, fullRailFill, measurements, railDetail, railCompare };

  useEffect(() => {
    let engine;
    try {
      engine = createEngine(host.current, products, {
        ...Object.fromEntries(['onSelect', 'onMode', 'onThumbnails', 'onRailDetail', 'onReady', 'onError'].map(key => [key, (...args) => callbacks.current[key](...args)])),
      }, roomConfig);
      ownedEngine.current = engine; apiRef.current = engine;
      syncEngine(engine, snapshot.current);
      applied.current = snapshot.current;
    } catch (error) { console.error(error); callbacks.current.onError('The 3D gallery could not start. Please enable WebGL or try another browser.'); }
    return () => {
      engine?.dispose();
      if (ownedEngine.current === engine) ownedEngine.current = null;
      if (apiRef.current === engine) apiRef.current = null;
      applied.current = {};
    };
  }, [products, apiRef, roomConfig]);

  useEffect(() => {
    if (!ownedEngine.current) return;
    syncEngine(ownedEngine.current, snapshot.current, applied.current);
    applied.current = snapshot.current;
  }, [products, selected, mtVariant, mode, openings, screenExtensions, finish, finishes, lighting, installation, fullRailFill, measurements, railDetail, railCompare]);
  return <div className="scene-host" ref={host} data-testid="showroom-scene"><span className="sr-only" data-testid="showroom-wall-brand">Viewlux Windows and Doors logo on the back wall</span></div>;
};